import { useState, useEffect, useCallback } from 'react';
/**
 * Custom hook to manage the static map preview state.
 * @param {boolean} useStaticMapProp
 * @param {boolean} initial
 * @returns
 */
export default function useStaticMapPreview(useStaticMapProp, initial = true) {
    const initialStatic = typeof useStaticMapProp === 'boolean' ? useStaticMapProp : initial;
    const [useStaticMap, setUseStaticMap] = useState(initialStatic);

    useEffect(() => {
        if (typeof useStaticMapProp === 'boolean') {
            setUseStaticMap(useStaticMapProp);
        }
    }, [useStaticMapProp]);

    const activate = useCallback(() => setUseStaticMap(false), []);

    const onKeyDown = useCallback(
        e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                activate();
            }
        },
        [activate]
    );

    return {
        useStaticMap,
        setUseStaticMap,
        activate,
        onKeyDown,
    };
}
